<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        title="Customer Discount Summary"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'reports', label: 'Reports' },
          { name: 'salesReport', label: 'Sales' },
          {
            name: 'salesOrderStatusDiscountUsage',
            label: 'Customer Discount Summary',
          },
        ]"
        @export="exportToCsv"
        :disableExport="!reportData"
      />
      <br class="no-print" />
      <ReportFilter
        class="no-print"
        :filterByTime="true"
        @submit-filter="performGetReport"
        :isLoading="salesTransactions"
      />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr class="report-body__row report-body__row--header"></tr>
              <tr><td colspan="3">Customer Discount Summary</td></tr>
              <tr><td colspan="3">{{ reportData.total.datePeriod }}</td></tr>
              <tr><td colspan="3">{{ reportData.total.customer }}</td></tr>
              <tr><td> </td></tr><tr><td> </td></tr>
              <tr>
                <th align="left">Date</th>
                <th align="left">Order #</th>
                <th align="right">Sub Total</th>
                <th align="right">Discount</th>
                <th align="right">Total</th>
                <th align="right">Discount %</th>
                <th align="right">Points</th>
                <th align="right">CCP</th>
                <th align="right">Coupon</th>
                <th align="right">Instant</th>
              </tr>
            </thead>

            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="(record, index) in reportData.records" :key="index">
                <td>{{ record.date }}</td>
                <td>{{ record.orderCode }}</td>
                <td align="right">
                  {{ Utilities.formatPrice(record.subTotal) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(record.discount) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(record.total) }}
                </td>
                <td align="right">
                  {{
                    Utilities.formatPercent(
                      (record.discount / record.subTotal) * 100
                    )
                  }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(record.points) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(record.ccp) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(record.coupon) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(record.instant) }}
                </td>
              </tr>
            </tbody>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
            <tr>
              <td colspan="2">Totals</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.subTotal) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.discount) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.total) }}
              </td>
              <td align="right">
                {{
                  Utilities.formatPercent(
                    (reportData.total.discount / reportData.total.subTotal) *
                      100
                  )
                }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.points) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.ccp) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.coupon) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.instant) }}
              </td>
            </tr>
            <tr class="skip-export"></tr>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      reportData: undefined,
      Utilities,
      reportType: undefined,
      selectedPeriod: undefined,
      selectedReportFor: undefined,
      selectedReportSaleType: undefined,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Customer Discount Summary");
  },
  mounted: function () {
    const today = new Date();
    this.selectedPeriod = {
      from: new Date(new Date().setDate(today.getDate() - 7)),
      to: today,
    };
  },
  computed: {
    ...mapGetters({
      loadingStatus: "reports/loadingStatus",
      salesTransactions: "reports/salesTransactions",
    }),
  },
  methods: {
    ...mapActions({
      getSalesTransactions: "reports/getSalesTransactions",
    }),
    performGetReport(filter) {
      let reportType = "salesOrderStatusDiscountUsage";
      this.getSalesTransactions({
        reportType,
        ...filter,
        positiveCallback: (data) => {
          this.reportData = data;
        },
      });
    },
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "salesOrderStatusDiscountUsage");
    },
  },
};
</script>

<style lang="scss">
@import "./_salesOrderStatusDiscountUsage.scss";
</style>